<template>
  <div class="introduction">
    <div class="introduction-title">{{ t('introduction.title') }}</div>
    <div class="introduction-text" v-html="sanitizedFooter"></div>
  </div>
</template>

<script setup lang="ts">
import { t } from '../composables/Translation'
import { useSanitizeHtml } from '../composables/SanitizeHtml'
import { computed } from 'vue'

const { sanitizeHtml } = useSanitizeHtml()
const sanitizedFooter = computed(() => sanitizeHtml(t('introduction.text')))
</script>

<style scoped lang="scss">
.introduction {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 21px;
}
.introduction-title {
  align-self: stretch;
  color: var(--text-color);
  font-size: 36px;
  font-weight: 600;
}
.introduction-text {
  align-self: stretch;
  color: var(--text-color);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

::v-deep(.introduction-text a) {
  color: var(--text-color);
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
</style>
